export default __webpack_public_path__ + "static/media/Elemental Ward.4d6d479a.jpg";